export default [
  {
    path: "/admin",
    component: () => import("@/views/reports/admin/AdministrationTools.vue"),
    redirect: to => to.path + "/recalculate",
    meta: {
      authorization: { policies: ["verensics-administrator"] },
    },
    children: [
      {
        path: "recalculate",
        component: () => import("@/views/reports/admin/EditOrganizationTests.vue"),
        meta: {
          authorization: { policies: ["verensics-administrator"] },
        },
      },
      {
        path: "spss",
        component: () => import("@/views/reports/admin/CreateSpssExcel.vue"),
        meta: {
          authorization: { policies: ["verensics-administrator"] },
        },
      },
      {
        path: "user-export",
        component: () => import("@/views/reports/admin/UserExport.vue"),
        meta: {
          authorization: { policies: ["verensics-administrator"] },
        },
      },
      {
        path: "report-details-export",
        component: () => import("@/views/reports/admin/ReportDetailsExport.vue"),
        meta: {
          authorization: { policies: ["verensics-administrator"] },
        },
      },
      {
        path: "failed-emails",
        component: () => import("@/views/reports/admin/FailedEmails.vue"),
        meta: {
          authorization: { policies: ["verensics-administrator"] },
        },
      },
    ],
  },
];
